import type { InjectionKey, Ref } from "vue";
import Snackbar from "../components/Snackbar.vue";
import type { CountryKey } from "../types";

export const countryKeyInjectionKey: InjectionKey<CountryKey> = Symbol();
export const snackbarInjectionKey: InjectionKey<Ref<InstanceType<typeof Snackbar> | null>> = Symbol();